/**
 * Utility file to test the API connection to the backend server
 */

/**
 * Tests the connection to the backend server
 * @returns {Promise} Promise that resolves with connection status
 */
export const testBackendConnection = async () => {
  // Use the same logic as emailService.js for consistency
  const isDevelopment = process.env.NODE_ENV === 'development' || 
                       (typeof window !== 'undefined' && window.location.hostname === 'localhost');
  
  const baseUrl = isDevelopment ? 'http://localhost:3001' : window.location.origin;
  
  console.log('Environment check:', {
    NODE_ENV: process.env.NODE_ENV,
    hostname: typeof window !== 'undefined' ? window.location.hostname : 'undefined',
    isDevelopment,
    baseUrl
  });

  try {
    console.log(`Testing connection to: ${baseUrl}/api/test`);
    const response = await fetch(`${baseUrl}/api/test`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      return {
        success: false,
        message: `Server responded with status: ${response.status} ${response.statusText}`
      };
    }

    const result = await response.json();
    console.log('API test successful:', result);
    return {
      success: true,
      message: 'Successfully connected to the backend server',
      data: result
    };
  } catch (error) {
    console.error('API connection test failed:', error);
    return {
      success: false,
      message: `Could not connect to backend: ${error.message}`,
      error
    };
  }
};
